export enum ModulesName {
  MY_DATA = 'my-data',
  TECHNICAL_VISIT = 'technical-visit',
}
